<template>
    <div>
        <div class="content-body">
            
            <!-- stats -->
            <div class="row" v-if="$store.state.listRole.client || $store.state.listRole.admin || $store.state.listRole.dispatcher">
                <div class="col-xl-4 col-lg-6 col-xs-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="media">
                                <div class="p-2 text-xs-center bg-cyan bg-darken-2 media-left media-middle">
                                    <i class="icon-checkmark22 font-large-2 white"></i>
                                </div>
                                <div class="p-2 bg-cyan white media-body">
                                    <h5>{{ $t('dashboard.titles.CEqs') }}</h5>
                                    <h5 class="text-bold-400">{{ countEq.Active }}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-6 col-xs-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="media">
                                <div class="p-2 text-xs-center bg-teal bg-darken-2 media-left media-middle">
                                    <i class="icon-security font-large-2 white"></i>
                                </div>
                                <div class="p-2 bg-teal white media-body">
                                    <h5>{{ $t('dashboard.titles.GEqs') }}</h5>
                                    <h5 class="text-bold-400">{{ countEq.Guarantee }}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-6 col-xs-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="media">
                                <div class="p-2 text-xs-center bg-deep-orange bg-darken-2 media-left media-middle">
                                    <i class="icon-sphere font-large-2 white"></i>
                                </div>
                                <div class="p-2 bg-deep-orange white media-body">
                                    <h5>{{ $t('dashboard.titles.AEqs') }}</h5>
                                    <h5 class="text-bold-400">{{ countEq.All }}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                

            </div>

            <div class="row" v-if="$store.state.listRole.service || $store.state.listRole.client || $store.state.listRole.admin || $store.state.listRole.dispatcher">
                <div class="col-xl-3">
                    <div class="card">
                        <div class="card-body">
                            <div class="card-block">
                                <div class="media">
                                    <div class="media-body text-xs-left">
                                        <h3 class="pink">{{ countTasks.All }}</h3>
                                        <span>{{ $t('dashboard.titles.ATasks') }}</span>
                                    </div>
                                    <div class="media-right media-middle">
                                        <i class="icon-bag2 pink font-large-2 float-xs-right"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-3">
                    <div class="card">
                        <div class="card-body">
                            <div class="card-block">
                                <div class="media">
                                    <div class="media-body text-xs-left">
                                        <h3 class="teal">{{ countTasks.New }}</h3>
                                        <span>{{ $t('dashboard.titles.NTasks') }}</span>
                                    </div>
                                    <div class="media-right media-middle">
                                        <i class="icon-file-empty teal font-large-2 float-xs-right"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-3">
                    <div class="card">
                        <div class="card-body">
                            <div class="card-block">
                                <div class="media">
                                    <div class="media-body text-xs-left">
                                        <h3 class="cyan">{{ countTasks.Progress }}</h3>
                                        <span>{{ $t('dashboard.titles.PTasks') }}</span>
                                    </div>
                                    <div class="media-right media-middle">
                                        <i class="icon-stack cyan font-large-2 float-xs-right"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-3">
                    <div class="card">
                        <div class="card-body">
                            <div class="card-block">
                                <div class="media">
                                    <div class="media-body text-xs-left">
                                        <h3 class="purple bg-lighten-1">{{ countTasks.Closed }}</h3>
                                        <span>{{ $t('dashboard.titles.CTasks') }}</span>
                                    </div>
                                    <div class="media-right media-middle">
                                        <i class="icon-clipboard2 purple bg-lighten-1 font-large-2 float-xs-right"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>

            <div class="row" v-if="$store.state.listRole.admin || $store.state.listRole.dispatcher">
                <div class="col-xl-4 col-lg-6 col-xs-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="card-block">
                                <div class="media">
                                    <div class="media-body text-xs-left">
                                        <h3 class="pink">{{ users.All }}</h3>
                                        <span>{{ $t('dashboard.titles.AUsers')}}</span>
                                    </div>
                                    <div class="media-right media-middle">
                                        <i class="icon-users2 pink font-large-2 float-xs-right"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-6 col-xs-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="card-block">
                                <div class="media">
                                    <div class="media-body text-xs-left">
                                        <h3 class="amber">{{ users.Clients }}</h3>
                                        <span>{{ $t('dashboard.titles.CUsers')}}</span>
                                    </div>
                                    <div class="media-right media-middle">
                                        <i class="icon-user-tie amber font-large-2 float-xs-right"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-6 col-xs-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="card-block">
                                <div class="media">
                                    <div class="media-body text-xs-left">
                                        <h3 class="deep-orange">{{ users.Service }}</h3>
                                        <span>{{ $t('dashboard.titles.SUsers')}}</span>
                                    </div>
                                    <div class="media-right media-middle">
                                        <i class="icon-user deep-orange font-large-2 float-xs-right"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
            <!--/ stats -->
            <!--/ project charts -->

            <div class="row" v-if="$store.state.listRole.client">
                <div class="col-md-12">
                    <div class="card" >
                        <div class="card-header">
                            <h4 class="card-title">{{ $t('dashboard.titles.mapEq') }}</h4>
                            <a class="heading-elements-toggle"><i class="icon-ellipsis font-medium-3"></i></a>
                        </div>
                        <div class="card-body">
                            <div class="row" >
                                <div class="col-md-12" v-if="this.$store.state.mapDashShow">
                                    <GmapMap ref="gmap" :center="mapCenterPos" :zoom="mapZoom" map-type-id="terrain" style="width: 100%; height: 60vh" :options="{
                                        zoomControl: true, mapTypeControl: false, scaleControl: false, streetViewControl: false, 
                                        rotateControl: false, fullscreenControl: true, disableDefaultUi: false}">
                                        <GmapMarker :key="index" v-for="(m, index) in markersEq"
                                            :position="m.position" 
                                            :clickable="true"
                                            :label = "m.label"
                                            :draggable="true"
                                            @click="mapCenterPos = m.position; openInfoWindowTemplate(m)"/>
                                            <gmap-info-window
                                                :options="{
                                                    maxWidth: 300,
                                                    pixelOffset: { width: 0, height: -35 }
                                                }"
                                                :position="infoWindow.position"
                                                :opened="infoWindow.open"
                                                @closeclick="infoWindow.open=false">
                                                <div v-html="infoWindow.template"></div>
                                            </gmap-info-window>
                                    </GmapMap>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>

            <div class="row" v-if="$store.state.listRole.service || $store.state.listRole.admin || $store.state.listRole.dispatcher">
                <div class="col-md-12 mb-1">  

                    <div class="card"> 
                        <div class="card-header">
                            <h3 class="card-title" :style="{fontFamily: fontFam}" style="text-transform: none;">{{ $t('dashboard.titles.grafTasks') }}</h3>
                        </div>
                        <div class="card-body">
                            <div class="card-block"><div class="row">
                                <div :style="{fontFamily: fontFam}">{{tasksPeriod.TitleChar}}
                                    <div class="tag" v-for="(st,index) in tasksPeriod.status" :key="index" :style="{fontFamily: fontFam, 'background-color': findColor(st.value)}">{{ st.title }}</div>
                                </div>
                                <GChart v-if="tasksPeriod.dataIs" ref="gChart" :type="tasksPeriod.typeChart" :data="tasksPeriod.data" :options="tasksPeriod.options" style="width: 100%; height: 100%;"/>    
                                <div class="text-xs-center d-flex align-items-center" v-if="!tasksPeriod.dataIs" style="height: 95% !important">
                                    <div class="w-100"><img :src="nodataImg" style="max-height: 100%; max-width: 100%"></div>
                                </div>
                            </div></div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>
</template>

<script>
  export default {
    name: "Dashboard",
    data(){
        return{
            countEq:{
                All: null,//AllGoods
                Active: null,//ActiveGoods
                Guarantee: null//GuaranteeGoods
            },
            countTasks:{
                All: null,//AllTasks
                New: null,//NewTasks
                Progress: null,//InProgressTasks
                Closed: null
            },
            users:{
                All: null,
                Clients: null,
                Service: null
            },
            mapZoom: 6,
            mapCenterPos: {lat:48.999626, lng:31.392785},
            markersEq:[],//{"title": 'Aksa Beach',"lat": '19.1759668',"lng": '72.79504659999998',"description": 'Aksa Beach, Mumbai.'}
            bounds: null,
            infoWindow: {
                position: {lat: 0, lng: 0},
                open: false,
                template: '',
            },

            fontFam: '"Segoe UI", Arial',
            nodataImg: require('../assets/pictures/noDataChart.svg'),
            tasksPeriod: {
                dataIs: false,
                typeChart: null, //ColumnChart LineChart AreaChart
                MainTitleChar: '', TitleChar: null,
                urls: [], status: [],
                data: [['', this.$t('dashboard.titles.NTasks'), this.$t('dashboard.titles.PTasks'), this.$t('dashboard.titles.CTasks')],['2021/4/20',4,2,1],["2021/4/21",2,6,4],['2021/4/22',10,9,4],["2021/4/21",2,6,4],["2021/4/21",2,6,4],["2021/4/21",2,6,4],["2021/4/21",2,6,4],["2021/4/21",2,6,4],["2021/4/21",2,6,4],["2021/4/21",2,6,4]],
                types: [],
                options: {
                    //title: 'Forecast by fiscal period',subtitle: '',
                    annotations: { textStyle: { fontSize: 17, bold: true, fontName: this.fontFam, textShadow: '3px 2px 5px black'}},
                    bars: { width: '100%' },
                    bar: {groupWidth: "70%"},
                    legend: { position: 'bottom', alignment: 'start', textStyle: {fontName: this.fontFam},},
                    //chartArea: {left: '5%', top: '5%', width: "95%", height: "75%"},
                    chartArea: {left: '5%', top: '5%', width: "90%", height: "75%"},
                    vAxis: {
                        viewWindow: {min: 0, max: 10},
                        textStyle: {fontName: this.fontFam},
                    },
                    hAxis: {textStyle: {fontName: this.fontFam}},
                    colors: ['#A7226E', '#EC2049', '#F26B38', '#F7DB4F', '#2F9599'],
                    width: '100%',
                    height: '100%',
                },
            },
        };
    },
    methods: {
        getWidg(){ 
            this.clearDataWidg();
            if( this.isValid(this.$store.getters.getGuidUser) ){
                let dataRequest = {
                    userGuid: this.$store.getters.getGuidUser,
                    days: 7
                };

                this.makeQuery("/service/infodashboard", {dataRequest : dataRequest, token: this.$store.getters.getUserToken })
                .then(result => {
                    this.$store.state.mapDashShow = false;

                    if(result.AllGoods != undefined){ this.countEq.All = result.AllGoods; }
                    if(result.ActiveGoods != undefined){ this.countEq.Active = result.ActiveGoods; }
                    if(result.GuaranteeGoods != undefined){ this.countEq.Guarantee = result.GuaranteeGoods; }

                    if(result.AllTasks != undefined){ this.countTasks.All = result.AllTasks; }
                    if(result.NewTasks != undefined){ this.countTasks.New = result.NewTasks; }
                    if(result.InProgressTasks != undefined){ this.countTasks.Progress = result.InProgressTasks; }
                    if(result.CloseTask != undefined){ this.countTasks.Closed = result.CloseTask; }

                    if(result.userCount != undefined){ 
                        if(result.userCount.countAllUsers != undefined){this.users.All = result.userCount.countAllUsers;}
                        if(result.userCount.countClient != undefined){this.users.Clients = result.userCount.countClient;}
                        if(result.userCount.countService != undefined){this.users.Service = result.userCount.countService;}
                    }

                    this.markersEq = [];

                    if(result.CoordinateArray != undefined){

                        //let bounds = new window.google.maps.LatLngBounds()
                        let sn2 = null;
                        let centrLng = 0, centrLat = 0;
                        for (let i = 0; i < result.CoordinateArray.length; i++) {
                            if((result.CoordinateArray[i].latitude != undefined) && (result.CoordinateArray[i].latitude != null)){
                                sn2 = null;
                                if((result.CoordinateArray[i].SN2 != undefined)&&(result.CoordinateArray[i].SN2 != undefined)){
                                    sn2 = result.CoordinateArray[i].SN2;
                                }

                                this.markersEq.push({ 
                                    //label: {text: result.CoordinateArray[i].SN, color: '#eb3a44', className: "labelMap"},
                                    serial: result.CoordinateArray[i].SN,
                                    position: {
                                        lng: parseFloat(result.CoordinateArray[i].longitude.replace(',','.').replace(' ','')),
                                        lat: parseFloat(result.CoordinateArray[i].latitude.replace(',','.').replace(' ',''))
                                    },
                                    serial2: sn2
                                });
                                centrLng = centrLng + parseFloat(result.CoordinateArray[i].longitude.replace(',','.').replace(' ',''));
                                centrLat = centrLat + parseFloat(result.CoordinateArray[i].latitude.replace(',','.').replace(' ',''));


                                /*bounds.extend({
                                    lng: parseFloat(result.CoordinateArray[i].longitude.replace(',','.').replace(' ','')),
                                    lat: parseFloat(result.CoordinateArray[i].latitude.replace(',','.').replace(' ',''))
                                });*/
                            }
                            //else {this.markersEq.push({ serial: result.CoordinateArray[i].SN,position: {lng: (Math.random(90)*100), lat: (Math.random(90)*100)} });}
                        }

                        if(this.markersEq.length > 0){
                            this.mapCenterPos = {lat: (centrLat/this.markersEq.length), lng: (centrLng/this.markersEq.length)};
                        }

                        /*if (bounds) {
                            this.$refs.gmap.fitBounds(bounds);
                            this.$refs.gmap.panToBounds(bounds);
                        }*/

                        this.$store.state.mapDashShow = true;
                        
                        /*
                        this.markersEq[i].serial
                        this.markersEq[i].position.lng
                        this.markersEq[i].position.lat

                        mapCenterPos.lng
                        mapCenterPos.lat
                        */
                    }

                    //------------------------------------------graf
                    this.tasksPeriod.dataIs = false;
                    if(this.$store.state.listRole.service){
                        this.tasksPeriod.typeChart = 'ColumnChart';
                    } else if(this.$store.state.listRole.admin || this.$store.state.listRole.dispatcher){
                        this.tasksPeriod.typeChart = 'AreaChart';
                    }

                    if(result.arrayDataGraphics != undefined){
                        this.tasksPeriod.data = [];
                        this.tasksPeriod.data.push(['', this.$t('dashboard.titles.NTasks'), this.$t('dashboard.titles.PTasks'), this.$t('dashboard.titles.CTasks')]);

                        for (let i = 0; i < result.arrayDataGraphics.length; i++) {

                            this.tasksPeriod.data.push([((result.arrayDataGraphics[i].gDate).split('T'))[0],
                                                        result.arrayDataGraphics[i].gNewTasks,
                                                        result.arrayDataGraphics[i].gInProgressTasks,
                                                        result.arrayDataGraphics[i].gClosedTasks
                            ]);

                            if(this.tasksPeriod.options.vAxis.viewWindow.max < result.arrayDataGraphics[i].gNewTasks) { this.tasksPeriod.options.vAxis.viewWindow.max = result.arrayDataGraphics[i].gNewTasks; }
                            if(this.tasksPeriod.options.vAxis.viewWindow.max < result.arrayDataGraphics[i].gInProgressTasks) { this.tasksPeriod.options.vAxis.viewWindow.max = result.arrayDataGraphics[i].gInProgressTasks; }
                            if(this.tasksPeriod.options.vAxis.viewWindow.max < result.arrayDataGraphics[i].gClosedTasks) { this.tasksPeriod.options.vAxis.viewWindow.max = result.arrayDataGraphics[i].gClosedTasks; }
                        }

                        if(this.tasksPeriod.data.length > 1){
                            this.tasksPeriod.dataIs = true;
                        }
                    }


                    


                    
                })
                .catch(result => {this.showNotification('custom-error','Error',result); });
            }
            
        },
        clearDataWidg(){
            this.countEq.All = 0;
            this.countEq.Active = 0;
            this.countEq.Guarantee = 0;

            this.countTasks.All = 0;
            this.countTasks.New = 0;
            this.countTasks.Progress = 0;
            this.countTasks.Closed = 0

            this.users.All = 0;
            this.users.Clients = 0;
            this.users.Service = 0;

            this.markersEq = [];
        },
        openInfoWindowTemplate(item) {
            this.infoWindow.position = { lat: item.position.lat, lng: item.position.lng };
            //this.infoWindow.template = `<h5><a class=""><i class="icon-location22"></i> ${item.serial}</a></h5> <p><span>${item.serial2}</span></p>` ;
            this.infoWindow.template = `<h5><a href="https://service.modern-expo.info/equipment/${item.serial}"><i class="icon-location22"></i> ${item.serial}</a></h5> <p><span>${item.serial2}</span></p>` ;
            //onclick="${this.openEq(item.serial)}'"
                
            this.infoWindow.open = true
        },
        openEq(serial){
            this.$router.push({ name: 'equipment', params: { serial: serial }, replace: true});
        }

    },
    created() {},
    mounted(){
        this.checkAuthorized()
        .then(result => {
            this.getWidg();

            if (this.isGoogle) {
                this.bounds = new window.google.maps.LatLngBounds()
            }

        })
        .catch(err => {
            this.showNotification('custom-error',this.$t('errors.title'),this.$t('errors.500'));
        });

        console.log(this.$store.state.listRole);
        
    }
  }
</script>
<style>
.labelMap{
    margin-bottom: 60px;
  border: 1px solid #eb3a44;
  border-radius: 5px;
  background: #fee1d7;
  text-align: center;
  line-height: 20px;
  font-weight: bold;
  font-size: 14px;
  color: #eb3a44;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue